export class Validations {
  static validateEmail(email: string): Boolean {
    if (
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/.test(
        email
      )
    ) {
      return true;
    } else {
      return false;
    }
  }
}
